import Navbar from "./components/NavBar/navbar";
import Intro from "./components/Intro/intro";
import Skills from "./components/Skills/skills";
import Galeri from "./components/Galeri/galeri";
import Service from "./components/Service/service";
import Footer from "./components/Footer/footer";

function App() {
  return (
    <div className="App" style={{ backgroundColor: '#062743' }}>
      <Navbar />
      <Intro />
      <Skills />
      <Galeri />
      <Service />
      <Footer />
    </div>
  );
}

export default App;
